import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { LocaleService } from '@app/core/i18n';
import { OrderLine } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-floating-cart-product',
  templateUrl: './floating-cart-product.component.html',
  styleUrls: ['./floating-cart-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FloatingCartProductComponent implements OnInit {
  public currency: any = {
    id: '38',
    symbol: '€',
    isoCode: 'EUR',
    name: 'Euros, Europe zone euro'
  };

  constructor(private localeService: LocaleService) {}

  @Input()
  orderLine: OrderLine;
  @Output()
  onRemove = new EventEmitter<OrderLine>();
  @Output()
  resetBox = new EventEmitter();

  ngOnInit() {
    this.currency = this.localeService.getCurrency();
  }

  remove(orderLine: OrderLine) {
    this.onRemove.emit(orderLine);
  }

  closePreviewBox() {
    this.resetBox.emit(true);
  }
}
